import React, { useMemo, memo } from 'react';
import { Content, Heading } from '@deephaven/components';
import { TimeUtils } from '@deephaven/utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var ConsoleHistoryItemTooltip = /*#__PURE__*/memo(props => {
  var item = props.item;
  var startTime = item.startTime,
    serverStartTime = item.serverStartTime,
    serverEndTime = item.serverEndTime;
  var endTime = useMemo(() => {
    var _item$endTime;
    return (_item$endTime = item.endTime) !== null && _item$endTime !== void 0 ? _item$endTime : Date.now();
  }, [item.endTime]);
  var timeString = TimeUtils.formatConvertedDuration(startTime, endTime);
  var hasTimeString = Boolean(timeString);
  var serverTimeString = null;
  if (serverStartTime != null && serverEndTime != null) {
    // server provided times are in nanoseconds
    serverTimeString = TimeUtils.formatConvertedDuration(serverStartTime, serverEndTime, 'ns');
  }
  var hasServerTimeString = Boolean(serverTimeString);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Heading, {
      children: "Execution Info"
    }), /*#__PURE__*/_jsx(Content, {
      children: /*#__PURE__*/_jsxs("div", {
        className: "console-history-item-contextual-help-content",
        children: [hasTimeString && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            children: "Elapsed time"
          }), /*#__PURE__*/_jsx("div", {
            children: timeString
          })]
        }), hasServerTimeString && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            children: "Server query time"
          }), /*#__PURE__*/_jsx("div", {
            children: serverTimeString
          })]
        })]
      })
    })]
  });
});
ConsoleHistoryItemTooltip.displayName = 'ConsoleHistoryItemTooltip';
export default ConsoleHistoryItemTooltip;
//# sourceMappingURL=ConsoleHistoryItemTooltip.js.map